import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=214b3789&lang=scss&scoped=true"

import exportComponent from "/Users/anxin/Documents/Vue/河南Vue网站/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-214b3789"]])

export default __exports__